import { components as rsComponents } from "react-select";
import { getBillyCookColorHex } from "utils/billyCookColors";

const OPTION_TEXT_COLOR = "#343434";

const ColorSwatch = ({ color, size = 16 }) => (
  <span
    aria-hidden
    className="inline-block shrink-0 rounded-full border border-black/15"
    style={{
      width: size,
      height: size,
      backgroundColor: getBillyCookColorHex(color),
    }}
  />
);

export function getBillyCookColorSelectProps(fieldName = "color", baseStyles = {}) {
  const Option = ({
    children,
    isSelected,
    innerRef,
    innerProps,
    data,
    isDisabled,
    ...rest
  }) => (
    <rsComponents.Option
      {...rest}
      data={data}
      isSelected={isSelected}
      isDisabled={isDisabled}
      innerRef={innerRef}
      innerProps={innerProps}
    >
      <div
        className="flex items-center"
        style={{ cursor: isDisabled ? "default" : "pointer", color: OPTION_TEXT_COLOR }}
      >
        <div className="mr-2 flex items-center">
          <input
            type="radio"
            checked={isSelected}
            readOnly
            disabled={isDisabled}
            name={`radio-${fieldName}`}
            className="cursor-pointer"
          />
        </div>
        <ColorSwatch color={data?.value} />
        <span className="ml-2">{children}</span>
      </div>
    </rsComponents.Option>
  );

  const SingleValue = ({ data, ...props }) => (
    <rsComponents.SingleValue {...props} data={data}>
      <div className="flex min-w-0 items-center gap-2 overflow-hidden">
        <ColorSwatch color={data?.value} />
        <span className="truncate">{data?.label}</span>
      </div>
    </rsComponents.SingleValue>
  );

  return {
    components: { Option, SingleValue },
    stylesOverride: {
      ...baseStyles,
      option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isFocused
          ? "#DEEBFF"
          : state.isSelected
            ? "#F0F4F8"
            : "transparent",
        color: OPTION_TEXT_COLOR,
        cursor: state.isDisabled ? "not-allowed" : "pointer",
      }),
    },
  };
}
